 
import React, { useState, FC } from 'react';
import AUReceiptComponent from '@aarhus-university/au-lib-react-components/src/components/AUReceiptComponent';
import MailSentReceiptComponent from '../common/MailSentReceiptComponent';
import {
  auIdRegex, emailRegex, renderValidation, validateForm,
} from '../../lib/validation';
import { useTranslationsContext } from '../../lib/translation';
import { useRequestUsernameRecoveryMutation } from '../../services/api';

const UsernameForgotComponent: FC = () => {
  const translations = useTranslationsContext();
  const [privateMailAddress, setPrivateMailAddress] = useState('');
  const [privateMailValidationMessages, setPrivateMailValidationMessages] = useState<string[]>([]);
  const [isPrivateMailValid, setIsPrivateMailValid] = useState(false);

  const [recover, response] = useRequestUsernameRecoveryMutation();
  const { isUninitialized, isSuccess, isLoading } = response;
  const saving = !isUninitialized && isLoading;
  const saved = !isUninitialized && isSuccess;

  const validationRules: IValidationRule[] = [{
    message: translations.forgot.validation.invalid,
    rule: (fieldValue: string) => {
      const trimmed = fieldValue.trim();
      const validMail = trimmed.match(emailRegex) !== null;
      const validAuId = trimmed.match(auIdRegex) !== null;
      return validMail || validAuId;
    },
  }];

  const validatePrivateMail = (value: string, alert = true) => {
    const [valid, messages] = validateForm(value, validationRules, translations.forgot.validation.valid);
    setPrivateMailAddress(value);
    setPrivateMailValidationMessages(alert ? messages : []);
    setIsPrivateMailValid(valid);
  };

  const handleSubmit = () => {
    validatePrivateMail(privateMailAddress, !isPrivateMailValid);
    if (isPrivateMailValid) {
      recover({
        userName: privateMailAddress,
      });
    }
  };

  if (saved) {
    return (
      <>
        <div className="page__content__block">
          <AUReceiptComponent
            receiptText={translations.forgot.receipt.header_username}
            showGoTo={false}
          />
        </div>
        <MailSentReceiptComponent
          mailReceiptHelp={translations.forgot.receipt.wrong_mail}
          goBackLink={`/${window.appLang}/user/forgot`}
        />
      </>
    );
  }

  let privateMailValidationClassName = '';
  if (!isPrivateMailValid && privateMailValidationMessages.length) {
    privateMailValidationClassName = ' form-info--error';
  } else if (isPrivateMailValid) {
    privateMailValidationClassName = ' form-info--confirmed';
  }

  return (
    <div className="page__content__block">
      <h1>{translations.forgot.username.header}</h1>
      <p>{translations.forgot.username.text}</p>
      <form
        className="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <div className={`form__field${privateMailValidationClassName}`}>
          <label key="label" htmlFor="mail-private">
            {translations.forgot.private_mail}
            <div className="form-info__hint">
              {translations.forgot.private_mail_hint_username}
            </div>
            {renderValidation(privateMailValidationMessages)}
          </label>
          <input
            type="text"
            id="mail-private"
            value={privateMailAddress || ''}
            onChange={(e) => {
              validatePrivateMail(e.target.value.trim(), privateMailValidationMessages.length > 0);
            }}
            disabled={saving}
          />
        </div>
        <div className="submit">
          <div className={`${saving ? 'submit-input-wrapper--processing' : ''}`}>
            <input
              className="button"
              type="submit"
              value={translations.forgot.username.next}
              disabled={saving}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

UsernameForgotComponent.displayName = 'UsernameForgotComponent';
export default UsernameForgotComponent;
